/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */

import { apiService } from './api.service';

// ===============================
// Types
// ===============================

export interface SendInviteRequest {
	email: string;
	fullname?: string;
	invitetype: 'coach-coachee' | 'coach-mentee' | 'platform';
	relatedcourseid: string;
	personalmessage?: string;
}

export interface VerifyInvitationResponse {
    id: string;
    email: string;
    fullname?: string;
    status: string;
    expiresat?: string;
    invitetype?: string;
    roleid?: string;
    rolename?: string;
    invitername?: string;
    inviteremail?: string;
    relatedcourseid?: string;
    organizationname?: string;
    phonenumber?: string;
}

export interface AcceptInvitationRequest {
    fullname?: string;
    username?: string;
    password: string;
    email?: string;
}

export interface AcceptInvitationResponse {
    user: any;
    tokens?: any;
}

export interface InviteSummary {
	id: string;
	email: string;
	fullname?: string;
	invitetype: string;
	status: string;
	personalmessage?: string;
	expiresat?: string;
	createdat: string;

	course: {
		id: string;
		title: string;
		thumbnail?: string | null;
	};
}
export interface CreateInviteRequest {
	email: string;
	fullname?: string;
	roleid?: string;
	phonenumber?: string;
	organizationname?: string;
	relatedcourseid?: string;
}

export interface CreateInviteResponse {
	id: string;
	email: string;
	fullname?: string;
	status: string;
	createdat: string;
	expiresat?: string;
}

type ApiResponse<T> = {
	success: boolean;
	message?: string;
	data: T;
};

// ===============================
// Invitation Service
// ===============================

export const invitationService = {
	// 🔹 Send Invite
	sendInvite: async (
		payload: SendInviteRequest
	): Promise<ApiResponse<InviteSummary>> => {
		try {
			const res = await apiService.post<ApiResponse<InviteSummary>>(
				'/invitations/send',
				payload
			);

			const response = (res as any).data ?? res;

			if (!response.success) {
				throw new Error(response.message || 'Failed to send invite');
			}

			return response;
		} catch (error: any) {
			console.error('sendInvite error:', error);

			return {
				success: false,
				message: error.message || 'Failed to send invite',
				data: {} as InviteSummary,
			};
		}
	},

	// ✅ NEW API
	createInvite: async (
		payload: CreateInviteRequest
	): Promise<ApiResponse<CreateInviteResponse>> => {
		try {
			 const response = await apiService.post<CreateInviteResponse>(
      '/invitation',
      payload
    );

    if (!response.success) {
      throw new Error(
        response.message || 'Failed to create invitation'
      );
    }

    return response;
		} catch (error: any) {
    console.error('createInvite error:', error);

    return {
        success: false,
        message:
            error?.response?.data?.message ||
            error.message ||
            'Failed to create invitation',
        data: {} as CreateInviteResponse,
    };
}
	},

	// 🔹 Cancel Invite
	cancelInvite: async (inviteId: string): Promise<ApiResponse<null>> => {
		try {
			const res = await apiService.delete<ApiResponse<null>>(
				`/invitation/${inviteId}` // ✅ matches your backend route
			);

			const response = (res as any).data ?? res;

			if (!response.success) {
				throw new Error(response.message || 'Failed to cancel invite');
			}

			return response;
		} catch (error: any) {
			console.error('cancelInvite error:', error);

			return {
				success: false,
				message: error.message || 'Failed to cancel invite',
				data: null,
			};
		}
	},

	verifyInvitation: async (
    token: string
): Promise<ApiResponse<VerifyInvitationResponse>> => {
    try {
        const response =
            await apiService.get<VerifyInvitationResponse>(
                `/invitation/verify/${token}`
            );

        if (!response.success) {
            throw new Error(
                response.message || 'Invalid invitation'
            );
        }

        return response;
    } catch (error: any) {
        console.error('verifyInvitation error:', error);

        return {
            success: false,
            message:
                error?.response?.data?.message ||
                error.message ||
                'Invalid or expired invitation',
            data: {} as VerifyInvitationResponse,
        };
    }
},


acceptInvitation: async (
    token: string,
    payload: AcceptInvitationRequest
): Promise<ApiResponse<AcceptInvitationResponse>> => {
    try {
        const response =
            await apiService.post<AcceptInvitationResponse>(
                `/invitation/accept/${token}`,
                payload
            );

        if (!response.success) {
            throw new Error(
                response.message || 'Failed to accept invitation'
            );
        }

        return response;
    } catch (error: any) {
        console.error('acceptInvitation error:', error);

        return {
            success: false,
            message:
                error?.response?.data?.message ||
                error.message ||
                'Failed to accept invitation',
            data: {} as AcceptInvitationResponse,
        };
    }
},
	

};
